var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWerbetechnikinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.01 0h39v39h-39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.774 20.042c-.526.084-.884.021-.665-.567.244-.657 1.17-1.364 1.602-.542.097.184.358.801-.021 1.165-.428.412-.593-.107-.916-.056z",
    fill: "url(#werbetechnik_inline_svg__werbetechnik_inline_svg___Linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.071 31.092a.275.275 0 00-.275-.275H13.79a.275.275 0 00-.275.275v.551c0 .152.123.275.275.275h6.006a.275.275 0 00.275-.275v-.551z",
    fill: "#1d4a68",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.244 27.674h1.036v3.087h-1.036z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.493 28.598l-.025-16.025s-.399-4.75 5.289-4.479c2.347.113 4.051 1.394 4.051 4.479 0 4.32-8.725 15.784-8.725 15.784l-.59.241z",
    fill: "url(#werbetechnik_inline_svg__werbetechnik_inline_svg___Linear2)",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "werbetechnik_inline_svg__werbetechnik_inline_svg___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(73.927 -2.563 22.421) scale(1.72095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005791",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ddf",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "werbetechnik_inline_svg__werbetechnik_inline_svg___Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.462 18.025) scale(9.09567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ee0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005792",
    stopOpacity: 1
  })))));
}

export default SvgWerbetechnikinline;